<template>
  <div>
    <div class="col-md-6 move-left">
      <div class="row distant-bottom">
        <div class="col-md-5">
          <span class="title">{{ $t("escalationstage.name") }}:</span>
        </div>
        <div class="col-md-7">
          <input
            v-model="escalation_stage.name"
            type="text"
            class="form-control"
          />
        </div>
      </div>
      <div class="row distant-bottom">
        <div class="col-md-5">
          <span class="title"
            >{{ $t("escalationstage.stage_due_date_no") }}:</span
          >
        </div>
        <div class="col-md-7">
          <input
            v-model="escalation_stage.stage_due_date_no"
            type="number"
            class="form-control"
          />
        </div>
      </div>
      <div class="row distant-bottom">
        <div class="col-md-5">
          <span class="title">{{ $t("escalationstage.stage_poc") }}:</span>
        </div>
        <div class="col-md-7">
          <b-form-select
            :options="staffs"
            v-model="escalation_stage.stage_poc"
            class="form-control"
          />
        </div>
      </div>
      <div class="row distant-bottom">
        <div class="col-md-5"></div>
        <div class="col-md-7">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onCancelStage"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-remove"></i>
            </span>
            {{ $t("common.cancel") }}
          </button>
          <button
            type="button"
            v-if="
              GET_ACCOUNT_DATA.id == 1 ||
                has_perm('update_case_escalation_stage') ||
                has_perm('create_case_escalation_stage')
            "
            class="btn btn-labeled btn-success"
            @click="onSaveStage"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils';

export default {
  name: "EscalationStageInput",
  data() {
    return {
      escalation_stage: {
        name: "",
        stage_due_date_no: 0,
        stage_poc: null
      },
      staffs: []
    };
  },
  watch: {
    STAFF_LIST: function() {
      let staffList = this.STAFF_LIST;
      let staffs = [];
      staffList.forEach(data => {
        let full_name = `${data.last_name} ${data.first_name}`;
        let item = {
          value: data.id,
          text: full_name
        };
        staffs.push(item);
      });
      this.staffs = staffs;
    }
  },
  computed: {
    ...mapGetters([
      "STAFF_LIST",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSaveStage() {
      let payload = this.escalation_stage;
      this.$emit("save", payload);
    },
    onCancelStage() {
      this.$emit("close", {});
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.distant-bottom {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/EscalationStageInput.vue